//Componentes generales
import { useEffect, useState, useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

// Alertas
import Swal from 'sweetalert2'

//Estilos
import { PRINCIPAL, NAVBARS,COLOR_BOTONES} from '../../constants/colors';

//Contextos
import tareaContext from '../../context/tareaContext/tareaContex';
import './FormControl.css';
import controlContext from '../../context/controlesContext/controlContex';

/*
    Componente encargado de mostrar el formulario de usuario.
        Donde data es el usuario crear/modificar.
              minimizar es la función encargada de ocultar el dialogo.
              generar es la función del context que guarda el usuario.
              titulo es la que determina que texto mostrar en encabezado del dialogo.
              verficaUser es la función del context que comprueba la licencia por usuario vigente del cliente.
*/
function FormControl({data,setData, minimizar, nuevoEditado, formDato, handleChangeControles, index, generar = () => console.log("Generando"), listaUsuarios = [], checklistID='' }){
    
    const cContext = useContext(controlContext);
    const {agregarControl, actualizarControlList, modificarControl, eliminarControl} = cContext;

    //State de usuario. Si no viene data por parametro significa que es nuevo por lo que se le asigna una estructura.
    const [control, setControl] = useState({codigo:"",name: '',descrp:"", showDescrp: false});
    
    //Constante que define el titulo que corresponde si vienen datos por parametros
    //const titulo = (data?.id === "" || data?.id ===  undefined) ? 'Agregar' : 'Modificar';
    const [titulo, setTitulo] = useState(nuevoEditado);

    //Funcion de validacion
    const validacion =  () => { 
        const newErrors = {};
        if (control.codigo === undefined || control.codigo === '') return newErrors.codigo = 'El código debe ser colocado'
        if (control.name === undefined || control.name === '') return newErrors.nombre = 'El nombre debe ser colocado'
        if (control.descrp === undefined || control.descrp === '') return newErrors.nombre = 'La descripción debe ser colocada'
        return '';
    };

    const handlerGenerar = async ()  => {
        
        const errorAxi = validacion();

        if ( errorAxi === "" ) {

            try {
                const dato = {...control};
                const res = await agregarControl(dato);
    
                if (res !== null) {
                    Swal.fire({
                        title: `Se guardo un nuevo Control`,
                        icon: 'success',
                        // text: `El Tipo de Activo es: ${res.name}`,
                        text: `Código: ${res.codigo} \n Nombre: ${res.name}`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                    actualizarControlList();
                    minimizar();
                } else {
                    Swal.fire({
                        title:  "Se esta repitiendo el código o nombre del Control",
                        icon: 'warning',
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                }
            } catch (error) {
                console.log(error);
            }

        }else{
            Swal.fire({
                title: errorAxi,
                icon: 'warning',
                showConfirmButton: true,
                allowEnterKey: true
            });
        }  
    }

    const handlerModificar = async () => {

        const errorAxi = validacion();

        if (errorAxi === "") {
    
            try {
                const dato = {
                    id: data.id,
                    codigo:control.codigo,
                    name: control.name,
                    descrp: control.descrp,
                    showDescrp: control.showDescrp
                }
                await setData(dato);
                const res = await modificarControl(dato);

                if (res !== null) {
                    Swal.fire({
                        title: `Se modificó el Control`,
                        icon: 'success',
                        text: `Nombre: ${res.name}\n Código: ${res.codigo}`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                    actualizarControlList();
                    minimizar();
                    let codigoToChange = {id: res._id, label: res.name, value: res.codigo, name: res.name, descrp: res.descrp, showDescrp: res.showDescrp};
                    handleChangeControles(codigoToChange,index); //Se actualiza la codigo seteada en el mantenimiento para modificar su descripcion.
                } else {
                    Swal.fire({
                        title:  "Se esta repitiendo el código o nombre del Tarea",
                        icon: 'warning',
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                }
            } catch (error) {
                console.log(error);
            }
        }else{
                Swal.fire({
                    title: errorAxi,
                    icon: 'warning',
                    showConfirmButton: true,
                    allowEnterKey: true
                });
        }  
    }

    const handlerEliminar = () => {
        Swal.fire({
            title: `Estas seguro que deseas eliminar esta Tarea?`,
            icon: 'warning',
            text: `Se eliminara permanentemente!`,
            showConfirmButton: true,
            showCancelButton: true, // Habilita el botón de cancelar
            confirmButtonText: 'Borrar',
            cancelButtonText:'No, cancelar',
            allowEnterKey: true

        }).then(async (result) => {
            if (result.isConfirmed) {
              // El usuario hizo clic en "Aceptar"
                const id = data.id
                const resp = await eliminarControl(id,checklistID);
                if(resp?.data?.deleted){
                    Swal.fire({
                        title: `Borrado!`,
                        icon: 'success',
                        text: `El control fue borrada correctamente!`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    })
                    actualizarControlList();
                    minimizar(null);
                    handleChangeControles({},index); //Se actualiza la codigo seteada en el mantenimiento para modificar su descripcion.
                }else{
                    Swal.fire({
                        title: `Operacion no puede realizarse`,
                        icon: 'error',
                        text: `${resp.data.msg}`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    })
                }
            } else if (result.isDismissed) {
             // El usuario hizo clic en "Cancelar" o en cualquier otro lugar fuera del diálogo
                minimizar();
            }
        });
    }

    useEffect(()=>{
        if(data !== undefined){
            //Se crea codigo ya que habia diferencias en el nombre de la propiedad cuando llegaba desde editarProcedimiento que cuando se agregaba una codigo nueva y se editaba.
            let codigo = (data.codigo != undefined) ? data.codigo : data.value;
            let controlModelado = {id:data?.codigoID, codigo:codigo, name: data?.name, descrp:data?.descrp, showDescrp: data.showDescrp};
            setControl(controlModelado);
        }
    },[data])

    return (
        <div className='container-group-form'>
            <div className='title-form-group' style={{backgroundColor: PRINCIPAL, color:NAVBARS}}>
                {titulo} Control
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Codigo de Control: </div>
                <input disabled={ titulo === "Modificar"} value={control.codigo} className='label-form-group-data' onChange={data => setControl({ ...control, ['codigo']:data.target.value })} />
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Nombre: </div>
                <input value={control.name} className='label-form-group-data' onChange={data => setControl({ ...control, ['name']: data.target.value })} />
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Descripción: </div>
                <textarea className='label-form-group-data' value={control.descrp} onChange={data => setControl({ ...control, ['descrp']: data.target.value })}/>
                <label style={{fontWeight:500}}>Descripción como alerta en checklist <span style={{color:'blue'}}>!!</span> <input id='checkboxShowDescrp' checked={control.showDescrp} type='checkbox' onChange={e => setControl({...control, showDescrp: e.target.checked})}/></label>
            </div>

            <div className='container-btn-group'>
                <button className='btn-form-group' style={{backgroundColor: COLOR_BOTONES, color:NAVBARS}} onClick={( titulo !== "Modificar") ? handlerGenerar : handlerModificar}>{titulo}</button> 
                {
                    (data !== "") &&(
                        <button className='btn-eliminar-form-group' onClick={handlerEliminar}>Eliminar</button>
                    )
                }
                {
                    titulo === "Modificar" ? (
                        <button className='btn-cancel-form-group' onClick={() => minimizar(data)}>Cancelar</button>
                    ) : (
                        <button className='btn-cancel-form-group' onClick={() => minimizar()}>Cancelar</button>
                    )
                }
            </div>
        </div>
    );
}

export default FormControl;